import { handleActions } from 'redux-actions';
import { produce } from 'immer';
import { addSelectedSeats, clearSelectedSeats, removeSelectedSeats, setSelectedSeatsBySegment } from './actions';
const initialState = {};
const selectedSeatsReducer = handleActions({
    [addSelectedSeats.toString()]: (state, { payload }) => produce(state, draft => {
        draft[payload.segmentId] = Object.assign(Object.assign({}, draft[payload.segmentId]), { [payload.passengerId]: payload.seats.map(seat => (Object.assign(Object.assign({}, seat), { segmentId: payload.segmentId, passengerId: payload.passengerId }))) });
    }),
    [removeSelectedSeats.toString()]: (state, { payload }) => produce(state, draft => {
        var _a;
        // tslint:disable-next-line:no-dynamic-delete
        (_a = draft[payload.segmentId]) === null || _a === void 0 ? true : delete _a[payload.passengerId];
    }),
    [clearSelectedSeats.toString()]: () => initialState,
    [setSelectedSeatsBySegment.toString()]: (state, { payload }) => {
        return produce(state, draft => {
            draft[payload.segmentId] = payload.seats;
        });
    }
}, initialState);
export default selectedSeatsReducer;
